<template>
  <svg class="icon" v-if="type">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
    },
  },
  data() {
    return {
      iconName: null,
    };
  },
  mounted() {
    this.iconName = `#${this.type}`;
  },
  watch: {
    type(val) {
      this.iconName = `#${val}`;
    },
  },
};
</script>

<style lang="less" scoped>
.icon {
  width: 16px;
  height: 16px;
}
</style>
